import { cn } from "@omni/utils/styles";

import { DeliveryDefault } from "./components/delivery/delivery.default";
import { PricingDefault } from "./components/pricing/pricing.default";
import { ECommerce as ECommerceBase } from "./eCommerce";
import { useECommerceProduct } from "./hooks/useECommerceProduct.hook";
import { useProductDetail } from "./hooks/useProductDetail.hook";

const EcommerceDefault = () => {
    const { isBoxArticle, isAdditionalService, hasComparisonSkus } =
        useECommerceProduct();
    const { stickyOrderButton } = useProductDetail();

    return (
        <>
            <div
                className={cn(
                    "tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:md:right-auto tw:layer-overlay/[0]",
                    "tw:p-2 tw:md:hidden",
                    "tw:bg-background",
                    {
                        "tw:hidden": !stickyOrderButton,
                        "tw:right-1/2": hasComparisonSkus
                    }
                )}
            >
                <ECommerceBase.OrderButton
                    className={cn("tw:pointer-events-auto", {
                        "tw:text-base!": hasComparisonSkus
                    })}
                />
            </div>
            <div
                className={cn(
                    "tw:bg-grey tw:border-grey-input tw:border tw:rounded-sm tw:p-4 tw:mb-6"
                )}
            >
                <ECommerceBase.SoldOutStamp />
                <div>
                    <ECommerceBase.Pricing>
                        <PricingDefault />
                    </ECommerceBase.Pricing>
                    <ECommerceBase.Variants />
                    <ECommerceBase.Delivery>
                        <DeliveryDefault />
                    </ECommerceBase.Delivery>
                </div>
                {!isAdditionalService && (
                    <div className={cn("tw:flex tw:items-center tw:mt-2")}>
                        {!isBoxArticle && <ECommerceBase.Compare />}
                    </div>
                )}
            </div>
            <ECommerceBase.StorPickers.Info />
            <ECommerceBase.StorPickers.Select />
        </>
    );
};

export { EcommerceDefault };
